// extracted by mini-css-extract-plugin
export var linkArrow = "linkWithArrow-module--link-arrow--xvzLw";
export var linkText = "linkWithArrow-module--link-text--1fHm3";
export var linkWithArrow = "linkWithArrow-module--link-with-arrow--pxq5s";
export var linkWithArrowSecondary = "linkWithArrow-module--link-with-arrow--secondary--ZetWS";
export var linkWithArrowTertiary = "linkWithArrow-module--link-with-arrow--tertiary--An6xE";